import * as React from "react";
import clockIcon from '../assets/images/clock.svg';
import { useState } from "react";
import { DataGrid, GridOverlay } from "@mui/x-data-grid";
import CircularProgress from "@mui/material/CircularProgress";
import { useEffect } from "react";
import { getHistoryActionLogs } from "../services/commonService";
import { ActionLogItem } from "./ActionLogItem";
import { useSelector } from "react-redux";

export const HistoryActionLogs = ({ estate }) => {

    const [actionLogsList, setActionLogsList] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [viewDetailShow, setViewDetailShow] = useState(false);

    const reduxProperty = useSelector(state => state.selectedProperty.selectedProperty);

    useEffect(() => {
        if (estate) {
            const getActionLogs = async () => {
                setIsLoading(true);

                let actionLogsObj = {
                    estateId: estate.id,
                    actionLogId: 0
                }

                const actionLogs = await getHistoryActionLogs(actionLogsObj);
                if (actionLogs.data) {
                    setActionLogsList(actionLogs.data);
                }
                setIsLoading(false);
            }
            getActionLogs();
        }

    }, [estate]);

    return (
        <>
            <div>
                <ActionLogItem actionLogsList={actionLogsList} isLoading={isLoading} viewDetailShow={viewDetailShow} setViewDetailShow={setViewDetailShow} estateId={estate.id} />
            </div>

        </>
    )
}


